import React, { useEffect, useState } from 'react';

// ==========================================
// 1. EFECTO: LLUVIA DE CORAZONES (Para Nella)
// ==========================================
const HeartsRain = () => {
  // Generamos corazones estáticos con propiedades random
  const [hearts] = useState(() => 
    Array.from({ length: 30 }).map((_, i) => ({
      id: i,
      left: Math.random() * 100, // Posición horizontal %
      delay: Math.random() * 5,  // Retraso de animación
      duration: 5 + Math.random() * 5, // Duración (velocidad)
      size: 1 + Math.random() * 1.5, // Tamaño (scale)
      emoji: ['❤️', '💖', '💗', '🥰'][Math.floor(Math.random() * 4)]
    }))
  );

  return (
    <div className="fixed inset-0 pointer-events-none z-50 overflow-hidden">
      {hearts.map((h) => (
        <div
          key={h.id}
          className="absolute bottom-[-50px] animate-float-up text-2xl opacity-0"
          style={{
            left: `${h.left}%`,
            animationDelay: `${h.delay}s`,
            animationDuration: `${h.duration}s`,
            transform: `scale(${h.size})`,
            // Estilo inline para la animación keyframe personalizada
            animationName: 'floatUp' 
          }}
        >
          {h.emoji}
        </div>
      ))}
      <style>{`
        @keyframes floatUp {
          0% { transform: translateY(0) scale(1) rotate(0deg); opacity: 0; }
          10% { opacity: 0.8; }
          100% { transform: translateY(-110vh) scale(1.2) rotate(360deg); opacity: 0; }
        }
        .animate-float-up {
          animation-timing-function: linear;
          animation-iteration-count: infinite;
        }
      `}</style>
    </div>
  );
};

// ==========================================
// 2. EFECTO: MODO HACKER / DEV (Ejemplo para ti)
// ==========================================
const MatrixGlitch = () => {
    return (
        <div className="fixed inset-0 pointer-events-none z-0 opacity-[0.3] bg-green-500 mix-blend-overlay">
            {/* Solo un tinte verde sutil estilo matrix sobre todo el perfil */}
        </div>
    )
}

// ==========================================
// COMPONENTE PRINCIPAL
// ==========================================
const ProfileEasterEggs = ({ username }) => {
    console.log(username);
  if (!username) return null;

  // Normalizamos para evitar errores de mayúsculas/minúsculas
  const user = username.toLowerCase().trim();

  // --- CONFIGURACIÓN DE USUARIOS ---
  const CONFIG = {
    'nella': <HeartsRain />,
    'martin': <MatrixGlitch />, // ¡Puedes ponerte uno a ti!
    // 'tu_amigo': <OtroEfecto />,
  };

  return CONFIG[user] || null;
};

export default ProfileEasterEggs;